module.exports = __webpack_public_path__ + "static/media/18-ValdezRojas(1).1a28b997.png";